import { render, staticRenderFns } from "./panelmenu-getmeback-logo.vue?vue&type=template&id=6b039c94&scoped=true&"
import script from "./panelmenu-getmeback-logo.vue?vue&type=script&lang=ts&"
export * from "./panelmenu-getmeback-logo.vue?vue&type=script&lang=ts&"
import style0 from "./panelmenu-getmeback-logo.vue?vue&type=style&index=0&id=6b039c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b039c94",
  null
  
)

export default component.exports